import React, { useEffect } from "react";
import E404 from  './../assets/newSvg/error/400.png'
import styled from "styled-components";
import PageTitlesFunc from "../components/Functions/PageTitlesFunc";

const Style = styled.div`
    display:flex ;
    flex-direction: column;
    align-items: center;
    justify-content:center ;
    position: relative;
    margin-top: var(--top-gap);
    height: 100%;
    .back-img{
        position: fixed;
        top: 0;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    .error-feild{
        display:grid ;
        grid-template-columns: repeat(2 , 50%);
        align-items: center;
        position: relative;
        margin: 10rem 0;
        .error-code{
            padding: 1rem;
            width: calc(100% - 2rem);
            display: flex;
            flex-direction: column;
            .code{
                width: 85%;
                position: relative;
                display: flex;
                color: var(--text-5);
                -webkit-text-stroke-color: #858DA4;
                -webkit-text-stroke-width: 2px;
                font-size: 240px;
                font-weight: 700;
                justify-content: center;
                align-items: center;
                text-align: center;
            }
            .line{
                width: 85%;
                height: 2px;
                background: #858DA4;
                margin-top: -4rem;
            }
        }
        .error-text{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .error-mgs{
                font-size: 2.5rem;
                font-weight: 900;
                color: var(--text-3)
            }
            .error-desc{
                font-size: 1.2rem;
                font-weight: 500;
                color: var(--gray-6);
                margin: 1rem 0 2rem;
            }
            .error-back{
                font-size: 0.87rem;
                font-weight: 400;
                color: var(--text-3);
                border: var(--border-style-5);
                border-radius: var(--border-radius-9);
                display: flex;
                background: none;
                flex-direction: row;
                align-items: center;
                width: max-content;
                padding: 0.5rem ;
                text-decoration: none;
                .arrow-circle{
                    border: var(--border-style-5);
                    border-radius: var(--border-radius-7);
                    padding: 0.2rem;
                    transform: rotate(180deg);
                    fill: var(--text-3);
                    width: 1rem;
                    height: 1rem;
                    aspect-ratio: 1;
                    margin-right: 0.2rem;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        height: 100vh;
        margin-top: 3rem;
        .back-img{
            height: 100vh;
        }
        .error-feild{
            grid-template-columns: 1fr;
            margin: 0 auto;
            .error-code{ 
                .code{
                    width: 100%;
                    font-size: 100px;
                }
                .line{
                    margin-top: 0;
                    margin-bottom: 2rem;
                    width: 100%;
                }
            }
            .error-text{
                margin: 0 var(--padding);
                .error-mgs{
                    font-size: 1.5rem;
                    margin: auto;
                }
                .error-desc{
                    text-align: center;
                    font-size: 1rem;
                }
            }
            .error-back{
                margin: auto;
            }
        }
    }
`
const NoMatch = ()=>{
    useEffect(()=>{
        window.scrollTo({
            top:0,
            behavior:'smooth'
        })
        PageTitlesFunc({
            title : 'Page Not Found - فروشگاه لوکسین لوکس'   , 
            description: "", 
        })
    },[])
    return(
        <Style>
            <img alt='404 not found' src={E404} className="back-img"/>
            <div className="error-feild">
                <div className="error-code">
                    <span className="code">404</span>
                    <span className="line"></span>
                </div>
                <div className="error-text"> 
                    <span className="error-mgs">
                    یه مشکلی پیش اومده!
                    </span>
                    <span className="error-desc">
                    صفحه ی مورد نظر در دسترس نمی باشد لطفا به صفحه اصلی برگردید و از آنجا دوباره شروع کنید  
                    </span>
                    <a href={'/'} className="error-back">
                        بازگشت به صفحه اصلی
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-circle">
                            <path d="M19.2398 25.0934C18.9865 25.0934 18.7332 25 18.5332 24.8C18.1465 24.4134 18.1465 23.7734 18.5332 23.3867L25.9198 16L18.5332 8.61337C18.1465 8.2267 18.1465 7.5867 18.5332 7.20003C18.9198 6.81337 19.5598 6.81337 19.9465 7.20003L28.0398 15.2934C28.4265 15.68 28.4265 16.32 28.0398 16.7067L19.9465 24.8C19.7465 25 19.4932 25.0934 19.2398 25.0934Z" />
                            <path d="M27.107 17H4.66699C4.12033 17 3.66699 16.5467 3.66699 16C3.66699 15.4533 4.12033 15 4.66699 15H27.107C27.6537 15 28.107 15.4533 28.107 16C28.107 16.5467 27.6537 17 27.107 17Z" />
                        </svg>
                    </a>
                </div>
            </div>
        </Style>
    )
}

export default NoMatch;